import {
  Container,
  Flex,
  Text,
  Heading,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableContainer,
  Grid,
  Box,
  Center,
  useToast,
} from "@chakra-ui/react";

import { AiFillCheckCircle, AiFillCloseCircle } from "react-icons/ai";
import { IoIosWarning } from "react-icons/io";
import RenewCreditModal from "./RenewCreditModal";
import { forEach } from "lodash";
import React from "react";
import { DEFAULT_TOAST_TIME } from "configuration";

export const days = [
  "Lunes",
  "Martes",
  "Miércoles",
  "Jueves",
  "Viernes",
  "Sabado",
  "Domingo",
];

function MiCredito({
  external_id,
  credit,
  pagados,
  tasaInteres,
  nextPaymentDate,
  misPagos,
  interesIVA,
  payment_day,
  globalEffectUpdate,
  is_paid,
  creditRenewal,
}) {
  let today = new Date();
  const toast = useToast;
  async function onClose() {
    const { status } = await creditRenewal(true);
    if (status) {
      globalEffectUpdate();
    } else {
      toast({
        position: "top",
        title: "Estamos experimentando intermitencia",
        description: "Inténtalo de nuevo mas tarde",
        status: "info",
        duration: DEFAULT_TOAST_TIME,
        isClosable: true,
      });
    }
  }

  async function onCloseWhithoutRenew() {
    const { status } = await creditRenewal(false);
    if (status) {
      globalEffectUpdate();
    } else {
      toast({
        position: "top",
        title: "Estamos experimentando intermitencia",
        description: "Inténtalo de nuevo mas tarde",
        status: "info",
        duration: DEFAULT_TOAST_TIME,
        isClosable: true,
      });
    }
  }
  let sinPagar = 0;

  const pagoSemanal = (
    (credit?.amount * tasaInteres + interesIVA + credit?.amount) /
    12
  ).toFixed(2);
  forEach(misPagos, (pago) => {
    if (!pago.is_paid) {
      sinPagar += pago.amount - pago.amount_paid;
    }
  });

  let paymentStatus = (payment) => {
    let missing_amount = payment.amount - payment.amount_paid;
    const date = new Date(payment.payment_date);
    if (payment.is_paid) return <AiFillCheckCircle size={30} color="green" />;
    if (date <= today) {
      return <AiFillCloseCircle size={30} color="red" />;
    }
    if (missing_amount > 0) {
      return <AiFillCheckCircle size={30} color="yellow" />;
    }
  };

  return (
    <>
      <Center>
        <RenewCreditModal
          isOpen={is_paid}
          onClose={onClose}
          onCloseWhithoutRenew={onCloseWhithoutRenew}
        />
      </Center>
      <Grid
        mb={10}
        templateColumns={{
          base: "repeat(1, 1fr)",
          md: "repeat(2, 1fr)",
        }}
        align={"center"}
        gap={{ base: "8", md: "5" }}
      >
        <Container maxW={"90vw"}>
          <Heading
            color={"blue.700"}
            w="100%"
            textAlign={"center"}
            fontWeight="normal"
            my="5%"
          >
            Mi Crédito
          </Heading>

          {/* Prioridad: Monto del préstamo */}
          <Flex justify="space-between" mb="3">
            <Text fontWeight="medium">Mi préstamo</Text>
            <Text color="blue.700">${credit?.amount}</Text>
          </Flex>

          {/* Prioridad: Mi pago semanal */}
          <Flex justify="space-between" mb="3">
            <Text fontWeight="medium">Mi pago semanal</Text>
            <Text color="blue.700">${pagoSemanal}</Text>
          </Flex>

          {/* Prioridad: Mis días de pago */}
          <Flex justify="space-between" mb="3">
            <Text fontWeight="medium">Mis días de pago</Text>
            <Text color="blue.700">
              Todos los <b>{days[payment_day]}</b>
            </Text>
          </Flex>

          {/* Prioridad: Fecha del próximo pago */}
          <Flex justify="space-between" mb="3">
            <Text fontWeight="medium">Fecha de próximo pago</Text>
            <Text color="blue.700">{nextPaymentDate}</Text>
          </Flex>

          {/* Prioridad: Pagos realizados */}
          <Flex justify="space-between" mb="3">
            <Text fontWeight="medium">Pagos realizados</Text>
            <Text color="blue.700">{pagados}/12</Text>
          </Flex>

          {/* Prioridad: Saldo remanente */}
          <Flex justify="space-between" mb="3">
            <Text fontWeight="medium">Saldo remanente</Text>
            <Text color="blue.700">${sinPagar.toFixed(2)}</Text>
          </Flex>

          {/* Espaciado antes de la caja azul */}
          <Box bg="blue.100" p="4" borderRadius="md" mt="6">
            <Heading size="md" mb="4" color="blue.700">
              Instrucciones de pago
            </Heading>
            <Text fontWeight="medium" mb="2">
              1. Nuestro método de pago predeterminado es el cobro automático a
              la cuenta bancaria registrada con el monto disponible en las
              fechas de pago.
            </Text>
            <Text fontWeight="medium" mb="2">
              2. También puedes hacer el pago a través de transferencia
              electrónica, sucursal bancaria o en tienda de conveniencia.
            </Text>
            <Text mb="2">
              <strong>Cuenta CLABE:</strong> 072180012405261830
            </Text>
            <Text mb="2">
              <strong>Número de cuenta:</strong> 1240526183
            </Text>
            <Text mb="2">
              <strong>Banco:</strong> Banorte
            </Text>
            <Text mb="2">
              <strong>Destinatario:</strong> PROMOTORA BUND SAPI DE CV
            </Text>
            <Text mb="2">
              <strong>Referencia Personal:</strong> {external_id}
            </Text>
            <Text mt="2">
              Es muy importante que coloques la referencia correcta para ubicar
              tu pago y que nos compartas el comprobante como imagen por
              WhatsApp al <strong>5523412346</strong> o a{" "}
              <strong>contacto@bund.com.mx</strong>
              <br />
              <Text as="b">
                *Tu pago se verá reflejado al día hábil siguiente en tu perfil
              </Text>
            </Text>
          </Box>
        </Container>

        <Container maxW={"90vw"}>
          <Heading
            color={"blue.700"}
            w="100%"
            textAlign={"center"}
            fontWeight="normal"
            my="5%"
          >
            Mis pagos
          </Heading>
          <TableContainer>
            <Table variant="striped">
              <Thead>
                <Tr>
                  <Th
                    style={{
                      maxWidth: "100px",
                      padding: "6px",
                      fontSize: "12px",
                    }}
                  >
                    Pago
                  </Th>
                  <Th
                    style={{
                      maxWidth: "100px",
                      padding: "6px",
                      fontSize: "12px",
                    }}
                  >
                    Cantidad
                  </Th>
                  <Th
                    style={{
                      maxWidth: "100px",
                      padding: "6px",
                      fontSize: "12px",
                    }}
                  >
                    Pendiente
                  </Th>
                  <Th
                    style={{
                      maxWidth: "100px",
                      padding: "6px",
                      fontSize: "12px",
                    }}
                  >
                    Fecha
                  </Th>
                  <Th
                    style={{
                      maxWidth: "100px",
                      padding: "6px",
                      fontSize: "12px",
                    }}
                  >
                    Estatus
                  </Th>
                </Tr>
              </Thead>
              <Tbody>
                {misPagos?.map(function (pago) {
                  const date = new Date(pago.payment_date);
                  date.setDate(date.getDate() + 1); // Sumar un día a la fecha

                  return (
                    <Tr key={pago.num_payment}>
                      <Td
                        style={{
                          maxWidth: "200px",
                          padding: "8px",
                          fontSize: "14px",
                        }}
                      >
                        {pago.num_payment}
                      </Td>
                      <Td
                        style={{
                          maxWidth: "200px",
                          padding: "8px",
                          fontSize: "14px",
                        }}
                      >
                        ${pago.amount}
                      </Td>
                      <Td
                        style={{
                          maxWidth: "200px",
                          padding: "8px",
                          fontSize: "14px",
                        }}
                      >
                        ${(pago.amount - pago.amount_paid).toFixed(2)}
                      </Td>
                      <Td
                        style={{
                          maxWidth: "200px",
                          padding: "8px",
                          fontSize: "14px",
                        }}
                      >{`${String(date.getDate()).padStart(2, "0")}/${String(
                        date.getMonth() + 1
                      ).padStart(2, "0")}/${date.getFullYear()}`}</Td>
                      <Td
                        style={{
                          maxWidth: "200px",
                          padding: "8px",
                          fontSize: "14px",
                        }}
                      >
                        {paymentStatus(pago)}
                      </Td>
                    </Tr>
                  );
                })}
              </Tbody>
            </Table>
          </TableContainer>
        </Container>
      </Grid>
    </>
  );
}

export default MiCredito;
